import angular from 'angular';

/**
 * @ngdoc overview
 * @name commonModule.form
 * @description
 * # commonModule.form
 * Module for managing the common directives.
 */
const form = angular.module('commonModule.form', []);

/**
 * @ngdoc directive
 * @name commonModule.form.directive:keyDown
 * @description
 * Directive for handling ESC key down.
 */
form.directive('keyDown', function () {
    'use strict';
    return function (scope, element, attrs) {
        element.bind('keydown keypress', function (event) {
            if ((angular.isDefined(attrs.keyCode) && parseInt(attrs.keyCode) === event.which) ||
                (angular.isUndefined(attrs.keyCode) && event.which === 27)) {
                scope.$apply(function () {
                    scope.$eval(attrs.keyDown);
                });
                event.preventDefault();
            }
        });
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:showErrors
 * @description
 * Directive for showing errors on forms.
 */
form.directive('showErrors', ['$timeout', 'showErrorsConfig', function ($timeout, showErrorsConfig) {
    'use strict';
    var getShowSuccess, linkFn;
    getShowSuccess = function (options) {
        var showSuccess;
        showSuccess = showErrorsConfig.showSuccess;
        if (options && options.showSuccess != null) {
            showSuccess = options.showSuccess;
        }

        return showSuccess;
    };
    linkFn = function (scope, el, attrs, formCtrl) {
        var blurred, inputEl, inputName, inputNgEl, options, showSuccess, toggleClasses;
        blurred = false;
        options = scope.$eval(attrs.showErrors);
        showSuccess = getShowSuccess(options);
        inputEl = el[0].querySelector('[name]');
        inputNgEl = angular.element(inputEl);
        inputName = inputNgEl.attr('name');

        if (!inputName) {
            throw 'show-errors element has no child input elements with a \'name\' attribute';
        }

        inputNgEl.bind('blur', function () {
            blurred = true;

            return toggleClasses(formCtrl[inputName].$invalid);
        });

        inputNgEl.bind('focus', function () {
            if (formCtrl[inputName]) {
                formCtrl[inputName].$setValidity('backend', true);
            }
        });

        scope.$watch(function () {
            return formCtrl[inputName] && formCtrl[inputName].$invalid;
        }, function (invalid) {
            if (!formCtrl[inputName] || !formCtrl[inputName].$error) {
                return;
            }

            var backendError = formCtrl[inputName].$error.backend;
            if (!blurred && (angular.isNullOrUndefined(backendError) || !backendError)) {
                return;
            }

            return toggleClasses(invalid);
        });

        scope.$on('show-errors-check-validity', function () {
            return toggleClasses(formCtrl[inputName].$invalid);
        });

        scope.$on('show-errors-reset', function () {
            return $timeout(function () {
                el.removeClass('has-feedback');
                el.removeClass('has-error');
                el.removeClass('has-success');

                return blurred = false;
            }, 0, false);
        });

        return toggleClasses = function (invalid) {
            el.toggleClass('has-feedback', invalid);
            el.toggleClass('has-error', invalid);
            if (showSuccess) {
                return el.toggleClass('has-success', !invalid);
            }
        };
    };

    return {
        restrict: 'A',
        require: '^form',
        compile: function (elem) {
            if (!elem.hasClass('form-group')) {
                throw 'show-errors element does not have the \'form-group\' class';
            }

            return linkFn;
        }
    };
}]);

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fieldErrors
 * @description
 * Directive for specyfing errors for specific input in form.
 */
form.directive('fieldErrors', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            fieldName: '@',
            inputErrors: '=',
            formErrors: '='
        },
        replace: true,
        transclude: true,
        require: '^form',
        link: function ($scope, el, attrs, formCtrl) {
            $scope.showInvalid = function (error) {
                var check;
                var fieldName = $scope.fieldName;

                if (!formCtrl[fieldName]) {
                    return false;
                }

                if (angular.isDefined(error)) {
                    if (angular.isDefined(error.type)) {
                        check = formCtrl[fieldName][error.type];
                    } else if (angular.isDefined(error.error)) {
                        check = formCtrl[fieldName].$error && formCtrl[fieldName].$error[error.error];
                    }
                } else {
                    check = formCtrl[fieldName].$invalid;
                }

                return check && formCtrl[fieldName].$error && !formCtrl[fieldName].$error.backend;
            };

            $scope.showBackendError = function () {
                return formCtrl[$scope.fieldName] && formCtrl[$scope.fieldName].$error && formCtrl[$scope.fieldName].$error.backend;
            };

            $scope.$watch('formErrors[fieldName]', function (newValue) {
                if (formCtrl[$scope.fieldName]) {
                    if (angular.isDefined(newValue)) {
                        formCtrl[$scope.fieldName].$setValidity('backend', false);
                    } else {
                        formCtrl[$scope.fieldName].$setValidity('backend', true);
                    }
                }
            });
        },
        templateUrl: 'views/common/components/form/fieldErrors.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:accessibleForm
 * @description
 * Directive for focusing on the first form input that is invalid.
 */
form.directive('accessibleForm', function () {
    'use strict';
    return {
        restrict: 'A',
        link: function (scope, elem) {
            var focusOnInvalid = function () {
                // find the first invalid element
                var firstInvalid = angular.element(elem[0].querySelector('.ng-invalid'))[0];
                // if found, set focus
                if (firstInvalid) {
                    firstInvalid.focus();
                }
            };
            // set up event handler on the form element
            scope.$on('show-errors-check-validity', function () {
                focusOnInvalid();
            });

            elem.on('submit', function () {
                focusOnInvalid();
            });
        }
    };
});

// Flow form controller
const flowFormController = ['$scope', '$modal', function ($scope, $modal) {
    'use strict';
    $scope.openModal = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/common/components/modals/libraryModal.tpl.html',
            controller: 'LibrariesModalController',
            size: 'xlg',
            animation: true
        });

        modalInstance.result.then(function (file) {
            $scope.imageShow = true;
            $scope.data = file.url;
        }).catch(() => {});
    };

    $scope.removeImage = function () {
        $scope.data = null;
    };
}];

// Common controller for file uploader
const fileUploadController = ['$scope', 'growl', function ($scope, growl) {
    'use strict';
    $scope.uploadChange = function ($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
        if (($files.length === 0) && ($event.type === 'drop' || $event.type === 'change')) {
            growl.error('ERROR.INVALID_FORMAT');
        }
    };
    $scope.$watch('upload', function (val) {
        if (angular.isDefined(val) && val) {
            const files = Array.isArray(val) ? val : [val];
            files.forEach(function (file) {
                if (angular.isDefined(file) && file) {
                    const fileReader = new FileReader();
                    fileReader.onload = function () {
                        if (typeof $scope.onUpload === 'function') {
                            $scope.onUpload({file: file});
                            $scope.$applyAsync();
                        }
                    };
                    fileReader.readAsArrayBuffer(file);
                }
            });
        }
    });
}];

/**
 * @ngdoc directive
 * @name commonModule.form.directive:planFileUpload
 * @description
 * Directive for handling level plan file upload.
 */
form.directive('miniFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/miniFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:planFileUpload
 * @description
 * Directive for handling level plan file upload.
 */
form.directive('planFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/planFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:jpgPngPdfFileUpload
 * @description
 * Directive for handling level plan file upload.
 */
form.directive('jpgPngFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/jpgPngFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fileUpload
 * @description
 * Directive for handling simple file upload.
 */
form.directive('fileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/fileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:flowForm
 * @description
 * Directive for handling ngFlow.
 */
form.directive('flowForm', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&',
            disable: '=?ngDisabled',
            data: '=?ngModel'
        },
        controller: flowFormController,
        templateUrl: 'views/common/components/form/flowForm.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:flowFormMini
 * @description
 * Directive for handling ngFlow mini version.
 */
form.directive('flowFormMini', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&',
            data: '=?ngModel'
        },
        controller: flowFormController,
        templateUrl: 'views/common/components/form/flowFormMini.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:requiredLabel
 * @description
 * Directive for appending 'required' HTML element to label of required input
 */
form.directive('requiredLabel', function () {
    'use strict';
    return {
        restrict: 'A',
        transclude: true,
        template: '<ng-transclude></ng-transclude> <span class="required">*</span>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:clientSelect
 * @description
 * Directive for client select
 */
form.directive('clientSelect', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            clientId: '=ngModel',
            isDisabled: '=ngDisabled',
            clientsPromise: '='
        },
        controller: ['$scope', '$modal', '$translate', 'Client', function ($scope, $modal, $translate, Client) {
            $scope.isLoading = true;

            var clientsPromise = angular.isDefined($scope.clientsPromise) ? $scope.clientsPromise : Client.getSelectList();

            clientsPromise
                .then(function (response) {
                    var data = response.data;
                    if (data.success) {
                        $scope.clients = data.clients;
                        $scope.client = {};
                        selectClient();
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });

            var revertedBack = false;
            $scope.$watch('clientId', function (newValue, oldValue) {
                // Only for the first time
                if (angular.isUndefined(newValue) || (angular.isDefined(newValue) && angular.isUndefined(oldValue))) {
                    selectClient();
                }
                if (!revertedBack && !$scope.clientNotFound && angular.isDefined(newValue) && angular.isDefinedNotNull(oldValue) && newValue !== oldValue) {
                    var modalInstance = $modal.open({
                        templateUrl: 'views/common/components/modals/confirmDialog.tpl.html',
                        controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                            $scope.ok = function () {
                                $modalInstance.close(true);
                            };

                            $scope.cancel = function () {
                                $modalInstance.close(false);
                            };

                            $scope.header = $translate.instant('MODULES.CLIENTS.CONFIRM.CHANGE_CLIENT_HEADER');
                            $scope.message = $translate.instant('MODULES.CLIENTS.CONFIRM.CHANGE_CLIENT_TEXT');
                        }]
                    });

                    modalInstance.result.then(function (isConfirmed) {
                        revertedBack = !isConfirmed;
                        if (!isConfirmed) {
                            $scope.clientId = oldValue;
                            if (oldValue === null) {
                                $scope.client = {};
                            } else {
                                selectClient();
                            }
                        }
                    }).catch(() => {});
                } else {
                    revertedBack = false;
                }
            });

            $scope.$watch('client.selected', function (value) {
                if (angular.isDefined(value)) {
                    $scope.clientId = value.id;
                }
            });

            var selectClient = function () {
                if (angular.isDefinedNotNull($scope.clientId)) {
                    angular.forEach($scope.clients, function (client) {
                        if (parseInt(client.id) === parseInt($scope.clientId)) {
                            $scope.client.selected = client;
                        }
                    });
                    $scope.clientNotFound = !$scope.client.selected;
                } else if (angular.isDefinedNotNull($scope.client) && angular.isDefinedNotNull($scope.client.selected)) {
                    $scope.clientId = $scope.client.selected.id;
                } else {
                    $scope.client = {};
                }
            };
        }],
        templateUrl: 'views/common/components/form/clientSelect.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:ngIndeterminate
 * @description
 * Directive for 'indeterminate' state of checkbox
 */
form.directive('ngIndeterminate', function () {
    'use strict';
    return {
        restrict: 'A',
        link: function (scope, element, attributes) {
            scope.$watch(attributes['ngIndeterminate'], function (value) {
                element.prop('indeterminate', !!value);
            });
        }
    };
});


/**
 * @ngdoc directive
 * @name commonModule.form.directive:appsoupCheckbox
 * @description
 * Directive for custom Appsoup checkbox
 *
 * Usage:
 * - add <span appsoup-checkbox></span> right after <input type="checkbox"/>
 * - add CSS class 'appsoup-checkbox' to parent element (e.g. label)
 */
form.directive('appsoupCheckbox', function () {
    'use strict';
    return {
        restrict: 'A',
        replace: true,
        template: '<i class="appsoup-checkbox-icon"></i>'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fileUpload
 * @description
 * Directive for handling simple file upload.
 */
form.directive('pdfFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/pdfFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fileUpload
 * @description
 * Directive for handling simple file upload.
 */
form.directive('allFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/allFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fileUpload
 * @description
 * Directive for handling simple file upload.
 */
form.directive('csvFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/csvFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fileUpload
 * @description
 * Directive for handling simple file upload.
 */
form.directive('csvXlsFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&',
            requiredFields: '='
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/csvXlsFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fileUpload
 * @description
 * Directive for handling simple file upload.
 */
form.directive('xlsFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/xlsFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fileUpload
 * @description
 * Directive for handling simple file upload.
 */
form.directive('pdfXlsXlsxFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/pdfXlsXlsxFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fileUpload
 * @description
 * Directive for handling simple file upload.
 */
form.directive('xmlFileUpload', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            onUpload: '&'
        },
        controller: fileUploadController,
        templateUrl: 'views/common/components/form/xmlFileUpload.tpl.html'
    };
});

/**
 * @ngdoc directive
 * @name commonModule.form.directive:fileReader
 * @description
 * Directive for handling file reading
 */
form.directive('fileReader', function () {
    'use strict';
    return {
        restrict: 'AE',
        scope: {
            fileReader: "="
        },
        link: function (scope, element) {
            $(element).on('change', function (changeEvent) {
                var files = changeEvent.target.files;

                if (files.length) {
                    var r = new FileReader();

                    r.onload = function (e) {
                        var contents = e.target.result;
                        scope.$apply(function () {
                            var rows = contents.split('\n');
                            var outRows = [];
                            outRows.push([files[0].name]);

                            angular.forEach(rows, function (cols) {
                                var tmpCols = cols.split(';');

                                if (tmpCols.length <= 1) {
                                    tmpCols = cols.split(',');
                                }

                                tmpCols = tmpCols.map(function (col) {
                                    return col.trim();
                                });

                                outRows.push(tmpCols);
                            });

                            scope.fileReader = outRows;
                        });
                    };

                    r.readAsText(files[0]);
                }
            });
        }
    };
});

export default form;
